<template>
  <div class="pa-layout pa-overlay-modal" :class="appendClass">
    <transition
     :name="contentTransitionName"

     @beforeEnter="beforeOpenContent"
     @enter="enterContent"
     @afterEnter="afterEnterContent"
     @afterLeave="afterLeaveContent"
    >
      <div class="pa-contents" v-if="isOpenCotnent" ref="contentField">
        <slot />
      </div>
    </transition>

    <transition
     :name="overlayTransitionName"

     @beforeEnter="beforeOpenOverlay"
     @afterEnter="afterEnterOverlay"
     @leave="leaveOverlay"
     @afterLeave="afterLeaveOverlay"
    >
      <div class="pa-overlay" ref="overlayField" v-if="isOpenOverlay" @click.prevent="clickOverlay"></div>
    </transition>
  </div>
</template>

<script>
export default {
  name    : 'PaOverlayModal',
  props   : {
    isOpen : {
      default : false,
    },

    isFreez : {
      default : false,
    },

    position : {
      default : {},
    },

    contentTransitionName : {
      default : 'pa-overlay-modal-content',
    },

    overlayTransitionName : {
      default : 'pa-overlay-modal-overlay',
    },

    appendClass : {
      default : [],
    },

    additionalZIndex : {
      default : 1,
    },

    bodyNoScroll      : {
      default: true
    },

    couldOverlaySwipeClose : {
      default: true
    }
  },

  data(){
    return {
      isOpenCotnent       : false,
      isOpenOverlay       : false,

      swipeOptions        : {
        pageWidth       : null,
        treshold        : null,

        touchstartX     : 0,
        touchstartY     : 0,
        touchendX       : 0,
        touchendY       : 0,

        limit             : null,
      },

      contentInitialPositionPercent : {
        bottom : 0,
      },

      initialZIndex                 : {
        content : 91,
        overlay : 90,
      },

      zIndexSet                     : {
        content : 91,
        overlay : 90,
      }
    };
  },

  computed : {
    opendModalCounter(){
      return this.$store.state.modal.opendModalCounter;
    }
  },

  watch   : {
    isOpen(value){
      if(value === true){
        this.isOpenOverlay = true;
      }else{
        this.isOpenCotnent = false;
      }
    },

    opendModalCounter : {
      handler(newValue){
        this.zIndexSet.content = this.zIndexSet.content + this.additionalZIndex + newValue;
        this.zIndexSet.overlay = this.zIndexSet.overlay + this.additionalZIndex + newValue;
      },
      immediate: true
    }
  },

  methods : {
    addCurrentModalLevel(){
      this.$store.dispatch('modal/addOpendModal', null, {root:true});
    },

    removeCurrentModalLevel(){
      this.$store.dispatch('modal/removeOpendModal', null, {root:true});
    },

    beforeOpenOverlay(){
      if(this.bodyNoScroll === true){
        this.$store.dispatch({
          type  : 'layouts/updateIsBodyNoScroll',
          value : true
        });
      }
      
      this.addCurrentModalLevel();

      this.$nextTick(() => {
        this.$refs.overlayField.style.zIndex = this.zIndexSet.overlay;
      });
    },

    beforeOpenContent(){
      this.$nextTick(() => {
        this.$refs.contentField.style.zIndex = this.zIndexSet.content;

        this.$emit('beforeEnterContent');
      });
    },

    enterContent(){
      if(typeof this.position !== 'undefined'){
        if(typeof this.position.botom !== 'undefined'){
          this.$refs.contentField.style.bottom = this.position.bottom;
        }
      }

      if(this.couldOverlaySwipeClose){
        this.initializeSwipeControl();
      }

      this.$emit('afterEnterContent');
    },

    afterEnterContent(){
      this.$emit('afteredAfterEnterContent');
    },

    afterLeaveContent(){
      if(this.bodyNoScroll === true && (this.opendModalCounter <= 1)){
        this.$store.dispatch({
          type  : 'layouts/updateIsBodyNoScroll',
          value : false
        });
      }

      this.isOpenOverlay = false;
      
      this.$emit('afterLeaveContent');
    },

    afterEnterOverlay(){
      this.isOpenCotnent = true;
    },

    leaveOverlay(){
      this.clearSwipeControl();
      this.removeCurrentModalLevel();
    },

    afterLeaveOverlay(){
      this.$emit('closeOverlayModal');
    },

    clickOverlay(){
      if(this.isFreez) return;
      
      this.isOpenCotnent = false;
    },

    initializeSwipeControl(){
      if(typeof this.$refs.contentField === 'undefined') return;
      // https://gist.github.com/SleepWalker/da5636b1abcbaff48c4d

      this.swipeOptions.pageWidth = window.innerWidth || document.body.clientWidth;
      this.swipeOptions.treshold  = Math.max(1,Math.floor(0.01 * (this.swipeOptions.pageWidth)));
      this.swipeOptions.limit     = Math.tan(45 * 1.5 / 180 * Math.PI);

      this.$refs.contentField.addEventListener('touchstart',  this.handleSwipeTouchStart, false);
      this.$refs.contentField.addEventListener('touchmove',   this.handleSwipeTouchMove,  false);
      this.$refs.contentField.addEventListener('touchend',    this.handleSwipeTouchEnd,   false);
    },

    clearSwipeControl(){
      if(typeof this.$refs.contentField === 'undefined') return;

      this.$refs.contentField.removeEventListener('touchstart',  this.handleSwipeTouchStart);
      this.$refs.contentField.removeEventListener('touchmove',   this.handleSwipeTouchMove);
      this.$refs.contentField.removeEventListener('touchend',    this.handleSwipeTouchEnd);
    },

    handleSwipeTouchStart(event){
      if(this.isFreez) return;

      this.swipeOptions.touchstartX = event.changedTouches[0].screenX;
      this.swipeOptions.touchstartY = event.changedTouches[0].screenY;
    },

    handleSwipeTouchMove(event){
      if(this.isFreez) return;

      if(typeof this.$refs.contentField === 'undefined') return;
      if(this.$refs.contentField.querySelector(':first-child') === null) return;

      if(this.swipeOptions.touchstartY < event.changedTouches[0].screenY){
        const diff = event.changedTouches[0].screenY - this.swipeOptions.touchstartY;

        if(typeof this.position !== 'undefined'){
          if(typeof this.position.top !== 'undefined'){
            const percent = (window.innerHeight * this.position.top);

            this.$refs.contentField.style.top = (percent + diff)+'px';
          }
          
          else if(typeof this.position.bottom !== 'undefined'){
            const percent = (window.innerHeight * this.position.bottom);

            this.$refs.contentField.style.bottom = (percent - diff)+'px';
          }
        }

        let opacityCalc = (1 - ((diff/2) / 100));

        if(opacityCalc < 0){
          opacityCalc = 0;
        }

        this.$refs.contentField.style.opacity = opacityCalc;
      }
    },

    handleSwipeTouchEnd(event){
      if(this.isFreez) return;

      this.swipeOptions.touchendX = event.changedTouches[0].screenX;
      this.swipeOptions.touchendY = event.changedTouches[0].screenY;

      let x = this.swipeOptions.touchendX - this.swipeOptions.touchstartX;
      let y = this.swipeOptions.touchendY - this.swipeOptions.touchstartY;
      let xy = Math.abs(x / y);

      if (Math.abs(x) > this.swipeOptions.treshold || Math.abs(y) > this.swipeOptions.treshold) {
        if (xy <= this.swipeOptions.limit) {
          if (!(y < 0)) {
            this.isOpenCotnent = false;
          }
        }
      }
    }
  }
}
</script>

<style lang="scss">
@import "~bulma/sass/utilities/_all";
@import "@/assets/scss/_variables.scss";

@keyframes PaOverlayModalAnimation
{
  0%   {
    bottom:-500px;
    opacity:0;
  }
  100% {
    bottom:0;
    opacity:1;
  }
}

@keyframes PaOverlayModalOverlayAnimation
{
  0%   {
    opacity:0;
    backdrop-filter: blur(0px);
  }
  100% {
    opacity:.9;
    backdrop-filter: blur(3px);
  }
}

.pa-overlay-modal-overlay{
  &-enter-active{
    animation: PaOverlayModalOverlayAnimation .5s;
  }

  &-leave-active {
    animation: PaOverlayModalOverlayAnimation .5s reverse;
  }

  &-enter, &-leave-to{
    opacity: 0;
  }
}

.pa-layout.pa-overlay-modal{
  overflow-y: scroll;
  user-select: none;
  margin-bottom:env(safe-area-inset-bottom);

  .pa-contents{
    position: fixed;
    left:0;
    // z-index: 1003; 
    z-index: 91;
    width: 100vw;
  }

  .pa-overlay{
    position: fixed;
    top:0;
    left:0;
    // z-index: 1002;
    z-index: 90;
    width: 100vw;
    height: 100vh;
    background:linear-gradient(0deg, rgba($body-background-darker, .7), rgba($body-background-darker, .5));
    backdrop-filter: blur(3px) opacity(.9);
  }

  &-bottom-transition{
    @keyframes PAOverlayModalBottomAnimation
    {
      0%   {
        bottom:-500px;
        opacity:0;
      }

      100% {
        bottom:0;
        opacity:1;
      }
    }

    // When User do swiper close, 0% position is dynamic, because could not use reverse option
    @keyframes PAOverlayModalBottomAnimationClose
    {
      0%   {
        bottom:inherit;
        opacity:inherit;
      }

      100% {
        bottom:-500px;
        opacity:0;
      }
    }

    .trans-content-bottom{
      &-enter-active{
        animation: PAOverlayModalBottomAnimation .5s;
      }

      &-leave-active{
        animation: PAOverlayModalBottomAnimationClose .5s;
      }

      &-leave, &-leave-active{
        bottom:inherit;
        opacity:inherit;
      }

      &-enter, &-leave-to{
        bottom:-500px;
        opacity: 0;
      }
    }

    .pa-contents{
      bottom:0;
    }
  }

  &-default-transition{
    @keyframes PAOverlayModalDefaultAnimation
    {
      0%   {
        top:100vh;
        opacity:0;
      }

      100% {
        top:15%;
        opacity:1;
      }
    }

    // When User do swiper close, 0% position is dynamic, because could not use reverse option
    @keyframes PAOverlayModalDefaultAnimationClose
    {
      0%   {
        top:inherit;
        opacity:inherit;
      }

      100% {
        top:100vh;
        opacity:0;
      }
    }

    @keyframes PAOverlayModalDefaultAnimationCloseTopFixed
    {
      0%   {
        top:15%;
        opacity:inherit;
      }

      100% {
        top:100vh;
        opacity:0;
      }
    }

    .trans-content{
      &-enter-active{
        animation: PAOverlayModalDefaultAnimation .5s;
      }

      &-leave-active{
        animation: PAOverlayModalDefaultAnimationClose .4s;
      }

      &-enter, &-leave-to{
        top:100vh;
        opacity: 0;
      }
    }

    .pa-contents{
      top:15%;
    }

    &-upper{
      @keyframes PAOverlayModalDefaultUpperAnimation
      {
        0%   {
          top:100vh;
          opacity:0;
        }

        100% {
          top:10%;
          opacity:1;
        }
      }

      .trans-content{
        &-enter-active{
          animation: PAOverlayModalDefaultUpperAnimation .5s;
        }

        &-leave-active{
          animation: PAOverlayModalDefaultAnimationClose .4s;
        }

        &-enter, &-leave-to{
          top:100vh;
          opacity: 0;
        }
      }

      .pa-contents{
        top:10%;
      }
    }

    &-upper-double{
      @keyframes PAOverlayModalDefaultUpperDoubleAnimation
      {
        0%   {
          top:100vh;
          opacity:0;
        }

        100% {
          top:5%;
          opacity:1;
        }
      }

      .trans-content{
        &-enter-active{
          animation: PAOverlayModalDefaultUpperDoubleAnimation .5s;
        }

        &-leave-active{
          animation: PAOverlayModalDefaultAnimationClose .4s;
        }

        &-enter, &-leave-to{
          top:100vh;
          opacity: 0;
        }
      }

      .pa-contents{
        top:5%;
      }
    }

    &-fix-for-tutorial{
      .trans-content{
        &-enter-active{
          animation: PAOverlayModalDefaultAnimation 1s;
        }

        &-leave-active{
          animation: PAOverlayModalDefaultAnimationCloseTopFixed .8s;
        }
      }

      .pa-contents{
        top:15%;
      }
    }
  }
}
</style>